import actions from './actions'
import mutations from './mutations'
import { createPagination, types } from '../pagination/pagination'
import axios from 'axios'

const state = {
  statusDashboardItems: void 0,
  dashboardItems: [],
  statusItem: void 0,
  item: {}
}

const pagination = createPagination({ perPage: 10 })

pagination.actions.getNews = async ({ commit, dispatch }, { perPage, page, sf, so, teamId }) => {
  commit(types.GET_LIST.REQUEST, { page })
  try {
    const result = await axios.get('/api/newsDashboardAll', { params: { l: perPage, lo: (page - 1), sf, so, teamId } })
    commit(types.GET_LIST.SUCCESS, result)
  } catch (err) {
    commit(types.GET_LIST.FAILURE)
  } finally {
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  modules: {
    pagination
  }
}
